import { loadLoyaltyIsBenefitAvailable } from ".";
import { EARLY_ACCESS_SALE } from "..";

const loadLoyaltyIsEarlyAccessSaleAvailableForTier = () =>
  loadLoyaltyIsBenefitAvailable(EARLY_ACCESS_SALE);

export default loadLoyaltyIsEarlyAccessSaleAvailableForTier;
